import { Navigate, Outlet } from 'react-router-dom';

type props = {
    url: string;
    isAllowed: boolean;
    children?: any;
}

function ProtectedRouter({url, isAllowed, children}:props) {
    if(!isAllowed){
        return <Navigate to={url}/>
    }
    return children ? children : <Outlet />
}

export default ProtectedRouter